export default __webpack_public_path__ + "static/media/rnr-sports-table-18.d11a1a3d.webp";